import {
  ResponsiveContainer,
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
} from 'recharts';

const campaignReach = [
  { campaign: 'AVIT LTO June', value: 92000 },
  { campaign: 'AVIT LTO July', value: 91000 },
  { campaign: 'Summer Splash', value: 64000 },
  { campaign: 'Game Day', value: 48000 },
  { campaign: 'Alexander Keith', value: 29000 },
];

const GOLD = '#eebf11';

const formatValue = (v) => {
  if (v >= 1e6) return `${(v / 1e6).toFixed(1)}M`;
  if (v >= 1e3) return `${Math.round(v / 1e3)}K`;
  return `${v}`;
};

function HeroTooltip({ active, payload, label }) {
  if (!active || !payload || !payload.length) return null;
  return (
    <div className="hero-chart-tooltip">
      <p className="hero-chart-tooltip-label">{label}</p>
      {payload.map((entry) => (
        <p key={entry.dataKey} className="hero-chart-tooltip-row">
          <span
            className="hero-chart-tooltip-dot"
            style={{ background: entry.color || entry.fill }}
          />
          {entry.name}: <strong>{formatValue(entry.value)}</strong>
        </p>
      ))}
    </div>
  );
}

export default function HeroPanel() {
  return (
    <div className="hero-panel" aria-hidden="true">
      <div className="hero-panel-card hero-panel-card--chart">
        <div className="hero-panel-chart-header">
          <div className="hero-panel-chart-heading">
            <span className="hero-panel-chart-title">Campaign View</span>
            <span className="hero-panel-chart-sub">Total reach by campaign</span>
          </div>
          <div className="hero-panel-chart-legend">
            <span><i className="legend-dot legend-dot--actual" /> Reach</span>
          </div>
        </div>

        <ResponsiveContainer width="100%" height={190}>
          <BarChart data={campaignReach} margin={{ top: 10, right: 8, left: 4, bottom: 24 }}>
            <defs>
              <linearGradient id="heroBarFill" x1="0" y1="0" x2="0" y2="1">
                <stop offset="0%" stopColor={GOLD} stopOpacity={1} />
                <stop offset="100%" stopColor={GOLD} stopOpacity={0.4} />
              </linearGradient>
            </defs>
            <CartesianGrid strokeDasharray="3 3" stroke="rgba(255,255,255,0.06)" vertical={false} />
            <XAxis
              dataKey="campaign"
              tick={{ fill: '#8c8c8c', fontSize: 9 }}
              axisLine={false}
              tickLine={false}
              angle={-20}
              textAnchor="end"
              interval={0}
              height={34}
            />
            <YAxis
              tick={{ fill: '#8c8c8c', fontSize: 10 }}
              axisLine={false}
              tickLine={false}
              width={36}
              tickFormatter={formatValue}
            />
            <Tooltip content={<HeroTooltip />} cursor={{ fill: 'rgba(255,255,255,0.04)' }} />
            <Bar dataKey="value" name="Reach" fill="url(#heroBarFill)" radius={[6, 6, 0, 0]} maxBarSize={38} />
          </BarChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
}
